/* Fills colorway chips with fabric: each chip shows a zoomed crop of the product photo, centred on
   a trouser leg at thigh height. */
(() => {
  const cache = new Map();

  function locate(url) {
    if (cache.has(url)) return cache.get(url);
    const job = new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        try {
          const w = 120;
          const h = Math.round((img.naturalHeight / img.naturalWidth) * w) || 150;
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0, w, h);
          const bg = ctx.getImageData(2, 2, 1, 1).data;
          let pick = null;
          for (const fy of [0.5, 0.46, 0.54, 0.42, 0.58, 0.38]) {
            const y = Math.round(fy * h);
            const row = ctx.getImageData(0, y, w, 1).data;
            const runs = [];
            let start = -1;
            for (let x = 0; x <= w; x++) {
              let on = false;
              if (x < w) {
                const i = x * 4;
                const d = Math.abs(row[i] - bg[0]) + Math.abs(row[i + 1] - bg[1]) + Math.abs(row[i + 2] - bg[2]);
                on = d > 40;
              }
              if (on && start < 0) start = x;
              if (!on && start >= 0) {
                if (x - start >= w * 0.05) runs.push({ a: start, b: x });
                start = -1;
              }
            }
            if (!runs.length) continue;
            runs.sort((r1, r2) => Math.abs((r1.a + r1.b) / 2 - w / 2) - Math.abs((r2.a + r2.b) / 2 - w / 2));
            const r = runs[0];
            const len = r.b - r.a;
            pick = { cx: (r.a + r.b) / 2 / w, cy: fy, len: len / w, ratio: h / w };
            break;
          }
          resolve(pick);
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = url;
    });
    cache.set(url, job);
    return job;
  }

  function apply(chip) {
    if (chip.dataset.klDone) return;
    chip.dataset.klDone = '1';
    const src = chip.dataset.klSrc;
    if (!src) return;
    locate(src).then((spot) => {
      if (!spot) return;
      const zoom = Math.min(24, Math.max(8, 1 / (spot.len * 0.6)));
      const pos = (f, scale) => Math.min(100, Math.max(0, ((scale * f - 0.5) / (scale - 1)) * 100));
      chip.style.backgroundImage = `url("${src}")`;
      chip.style.backgroundSize = `${zoom * 100}%`;
      chip.style.backgroundPosition = `${pos(spot.cx, zoom).toFixed(2)}% ${pos(spot.cy, zoom * spot.ratio).toFixed(2)}%`;
    });
  }

  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            io.unobserve(e.target);
            apply(e.target);
          }
        });
      }, { rootMargin: '200px 0px' })
    : null;

  function scan(root) {
    root.querySelectorAll('[data-kl-chip]').forEach((chip) => {
      if (chip.dataset.klDone || chip.dataset.klSeen) return;
      chip.dataset.klSeen = '1';
      if (io) io.observe(chip);
      else apply(chip);
    });
  }

  const start = () => {
    scan(document);
    new MutationObserver((records) => {
      for (const r of records) r.addedNodes.forEach((n) => n.nodeType === 1 && scan(n));
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
